/* eslint-disable-next-line */
export interface AudioControllerProps {
  handleClick: React.MouseEventHandler<HTMLDivElement>;
  path: string;
}

export function AudioController(props: AudioControllerProps) {
  const { handleClick, path } = props;
  return (
    <div
      onClick={handleClick}
      className=" cursor-pointer  hover:bg-blue-500 hover:text-white border rounded-full h-10 w-10 flex items-center justify-center self-center  bg-white"
    >
      <svg
        className="w-6 h-6"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path d={path} />
      </svg>
    </div>
  );
}

export default AudioController;
